import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=94831b54&scoped=true&"
import script from "./ColourPicker.vue?vue&type=script&lang=js&"
export * from "./ColourPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColourPicker.vue?vue&type=style&index=0&id=94831b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94831b54",
  null
  
)

export default component.exports